export default class Image {

    constructor(json) {
        this.json = json;
    }

    get url() {
        if (getLanguage() === 'fr') {
            return this.json.urlFr;
        } else if (getLanguage() === 'it') {
            return this.json.urlIt;
        } else {
            return this.json.urlDe;
        }
    }

    get alt() {
        if (getLanguage() === 'fr') {
            return this.json.altFr;
        } else if (getLanguage() === 'it') {
            return this.json.altIt;
        } else {
            return this.json.altDe;
        }
    }
}